export default __webpack_public_path__ + "static/media/david-anolick.59ac320d.png";